export default function emailSecretMask(email) {
  if (email) {
    const splitEmail = email.split('@');
    return `${splitEmail[0][0]}${splitEmail[0][1]}****@${splitEmail[1]}`;
  }

  return email || '';
}
